import DataLoader from "dataloader";
import settings from "./settings";
import uniqBy from "lodash/uniqBy";
import find from "lodash/find";
import { getClientProps } from "./utils";

const { vaixClientId, baseApiUrl } = settings;
const { apiAuthToken } = getClientProps();

/**
 * Send a batch of requests to the fabric vaix API and retrieve responses.
 *
 * This function sends a batch of requests to the fabric `/api/batch` endpoint, deduplicating the requests
 * based on their "name" property. It then processes the API responses and maps them to the
 * corresponding original requests based on the "name" property.
 *
 *
 * @param {Array.<{operation_id: string, name: string, params: object}>} requests - An array of request objects,
 * each containing an "operation_id" (string), "name" (string), and "params" (object) properties.
 * @returns {Promise} A Promise that resolves to an array of responses corresponding to the input requests.
 */
const fabricBatchFn = (requests) => {
  const body = { requests: uniqBy(requests, "name") };

  return fetch(`${baseApiUrl}/api/batch`, {
    method: "POST",
    headers: {
      origin: "",
      authorization: `Bearer ${apiAuthToken}`,
      "x-vaix-client-id": vaixClientId,
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      return response.json();
    })
    .then(({ data }) => {
      return requests.map((r) => {
        return find(data, (req) => req?.name === r?.name).body;
      });
    })
    .catch((error) => {
      throw error;
    });
};

const FabricLoader = new DataLoader(fabricBatchFn, {
  maxBatchSize: 10,
  cache: false,
});

export default FabricLoader;
